import React from 'react'
import { Button, Container, Table, Tooltip, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as AiIcons from "react-icons/ai";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Supplier ID</th>
        <th style={{width:'50%'}}>Supplier Name</th>
        <th className='d-none d-sm-table-cell'>Contact Person</th>
        <th className='d-none d-sm-table-cell'>Phone</th>
        <th className='d-none d-sm-table-cell'>Email</th>
        <th style={{width:'5%'}}>{props.mode==0?'Edit':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.suppliersObj) {
    const rows = props.suppliersObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.suppliername}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.suppliercontactperson}
          </td>        
          <td className='d-none d-sm-table-cell'>  
            {row.suppliercontactphone}
          </td>   
          <td className='d-none d-sm-table-cell'>  
            {row.suppliercontactemail}
          </td>            
          <td align='center'>  
            {(props.mode==0) &&
              <Link to = {`/editsupplierpage/${row.id}`}><AiIcons.AiFillEdit /></Link>      
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.suppliername,row.suppliercontactperson);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            }            
          </td>     
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the patient.
  </Tooltip>
);



const SuppliersList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />            
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} suppliersObj={props.listOfSuppliers} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default SuppliersList;